import React from 'react';
import Joyride, { STATUS, CallBackProps, Step } from 'react-joyride';
import './ProductTour.scss';

interface ProductTourProps {
  isOpen: boolean;
  onComplete: () => void;
  onExit: () => void;
}

export const ProductTour: React.FC<ProductTourProps> = ({ isOpen, onComplete, onExit }) => {
  const steps: Step[] = [
    {
      target: '.specialty-selector',
      content: 'Welcome to SimPLAB2! Let\'s start by selecting a specialty. Click on Cardiology to begin.',
      placement: 'right',
      disableBeacon: true
    },
    {
      target: '[data-topic-id="acs"]',
      content: 'For your first case, let\'s try an ACS (Acute Coronary Syndrome) scenario.',
      placement: 'bottom'
    }
  ] as Step[];

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;
    
    const isFinished = status === STATUS.FINISHED || status === STATUS.SKIPPED;
    if (isFinished) {
      localStorage.setItem('hasSeenProductTour', 'true');
      onComplete();
    }

    if (status === STATUS.SKIPPED) {
      localStorage.setItem('hasSeenProductTour', 'true');
      onExit();
    }
  };

  return (
    <Joyride
      run={isOpen}
      steps={steps}
      continuous
      showProgress
      showSkipButton
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: '#007bff',
          zIndex: 10000,
          arrowColor: '#fff',
          backgroundColor: '#fff',
          textColor: '#333',
          width: 320,
        },
        tooltipContainer: {
          textAlign: 'left',
          padding: '20px'
        },
        buttonNext: {
          backgroundColor: '#007bff',
          fontSize: '14px',
          padding: '8px 15px'
        },
        buttonBack: {
          marginRight: '10px',
          fontSize: '14px',
          padding: '8px 15px'
        },
        buttonSkip: {
          color: '#666',
          fontSize: '14px'
        }
      }}
    />
  );
}; 